<div class="tw-font-bold">{{ locationName }}</div>
<div>ジオフェンス：{{ geofenceText }}</div>
<div>住所：{{ address }}</div>

@if (displayButtonOnPopup) {
  <div class="tw-flex tw-flex-col tw-gap-y-2 tw-mt-4 tw-w-[135px]">
    @if (locationType !== "start") {
      <button
        mat-stroked-button
        type="button"
        class="matp-small-button"
        id="update-to-start-btn"
        color="primary"
        (click)="
          locationTypeButtonClicked.emit({
            locationId: locationId,
            locationType: 'start',
          })
        "
      >
        <mat-icon>sync_alt</mat-icon>
        <span>出発地に変更</span>
      </button>
    }

    @if (locationType !== "arrival") {
      <button
        mat-stroked-button
        type="button"
        class="matp-small-button"
        id="updat e-to-arrival-btn"
        color="primary"
        (click)="
          locationTypeButtonClicked.emit({
            locationId: locationId,
            locationType: 'arrival',
          })
        "
      >
        <mat-icon>sync_alt</mat-icon>
        <span>到着地に変更</span>
      </button>
    }
  </div>
}
